import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta15 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-15/utils-consultaSeguimentoPergunta15'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { convertAplicacaoPergunta15 } from './converter-HistoricoMchatPergunta15'

interface HistoricoMChatRfPergunta15Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta15 = (props: Readonly<HistoricoMChatRfPergunta15Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta15(aplicacoes)
  if (converted == null) return null

  const { header, tentaImitar, model } = converted
  if (header === null) return null

  const resultado = calculateResultadoPergunta15(model)
  const hasTentaImitar = tentaImitar.isNotEmpty()

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='15'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta='“O seu filho tenta lhe imitar, se você...”'
      />
      {hasTentaImitar && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={tentaImitar} />}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
